export default "__VITE_ASSET__GcrlSu3L__"